import styled from 'styled-components';

export const WrapperNaming = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 0.3fr 3fr;
  width: 100%;
`;

export const AvataiContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const AvatarUser = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
`;

export const ContainerName = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  margin-left: 0.3rem;
`;

export const Name = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
  text-align: left;
  white-space: nowrap;

  @media (max-width: 1200px) {
    white-space: wrap;
  }
`;

export const Me = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;
  margin-left: 0.3rem;
  color: ${({ theme }) => theme.colors.button.text.disabled};
`;

export const Email = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-align: left;
`;
